module.exports = __webpack_public_path__ + "img/GIFTO.9681727b.svg";